import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  display_name: string;
  role: 'admin' | 'student';
  avatar_url: string | null;
  created_at: string;
  updated_at?: string;
  job_role?: string;
  bio?: string;
  phone?: string;
  employee_number?: string;
};

export type Workspace = {
  id: string;
  name: string;
  description: string | null;
  invite_code: string;
  owner_id: string;
  play_mode: 'A' | 'B';
  is_active: boolean;
  created_at: string;
};

export type CompanyState = {
  id: string;
  workspace_id: string;
  user_id: string;
  capital: number;
  reputation: number;
  credit_score: number;
  active_projects: number;
  updated_at: string;
};
